import { Skeleton } from 'antd';
import { useShallow } from 'zustand/react/shallow';
import {
  CardPanelSubTitle,
  CardPanelTitle,
  CardPanelValue,
  CardsContainer,
  CardsPanelContainer,
  CardsPanelSubtitle,
  CardsPanelTitle,
  CardsPanelTitleContainer,
  TitleContainer,
} from '~/components/bosons/CardsPanel.styled';
import { currencyFormatter } from '~/helpers/util/number';
import useSaleStatementByTypeStore from '~/zustand/salesStatement/useSalesStatementByTypeStore';

export default function SalesStatementCardsPanel() {
  const { cardPanel, isLoading } = useSaleStatementByTypeStore(
    useShallow(state => ({
      cardPanel: state.intermediationCardPanel.data,
      isLoading: state.intermediationCardPanel.isLoading,
    })),
  );

  const renderCardValue = (value: React.ReactNode) => {
    if (isLoading) {
      return <Skeleton.Input active size="small" style={{ width: 100 }} />;
    }

    return value;
  };

  return (
    <div style={{ margin: '0 !important' }}>
      <TitleContainer>
        <CardsPanelTitle>Resultados das Vendas</CardsPanelTitle>
        <CardsPanelSubtitle>Acompanhe os grandes números no período selecionado</CardsPanelSubtitle>
      </TitleContainer>

      <CardsContainer>
        <CardsPanelContainer>
          <CardsPanelTitleContainer>
            <CardPanelTitle>Origem mais utilizada</CardPanelTitle>
            <CardPanelSubTitle>
              Por qual origem de intermediação houve mais pedidos
            </CardPanelSubTitle>
          </CardsPanelTitleContainer>
          <CardPanelValue>{renderCardValue(cardPanel.salesChannel)}</CardPanelValue>
        </CardsPanelContainer>

        <CardsPanelContainer>
          <CardsPanelTitleContainer>
            <CardPanelTitle>Quantidade de vendas</CardPanelTitle>
            <CardPanelSubTitle>Soma das quantidades totais dos pedidos</CardPanelSubTitle>
          </CardsPanelTitleContainer>
          <CardPanelValue>{renderCardValue(cardPanel.totalQuantity)}</CardPanelValue>
        </CardsPanelContainer>

        <CardsPanelContainer primary>
          <CardsPanelTitleContainer>
            <CardPanelTitle>Total de Vendas</CardPanelTitle>
            <CardPanelSubTitle>Soma dos valores totais de cada pedido</CardPanelSubTitle>
          </CardsPanelTitleContainer>
          <CardPanelValue primary>
            {renderCardValue(currencyFormatter(cardPanel.totalValue))}
          </CardPanelValue>
        </CardsPanelContainer>
      </CardsContainer>
    </div>
  );
}
